// extracted by mini-css-extract-plugin
module.exports = {"file-upload":"_1OHFns","input":"_1_lIQp"};